import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useFormikContext } from 'formik'
import debounce from 'lodash/debounce'

import { config } from '../../../Init/Init'
import { depositFormFields } from '../../cryptoPaymentConstants'
import {
  formatCurrencyAmount,
  formatCurrencyAmountFromConfig,
  getCryptoCurrencyConfigForCryptoId
} from '../../../../services/utils'
import { constants } from '../../../../componentsConstants'

export const useOnCoinsAmountChange = exchangeRate => {
  const [updatedSectionName, setUpdatedSectionName] = useState('')
  const { setFieldValue, values } = useFormikContext()
  const sectionAnimationTimerRef = useRef(null)

  const cryptoCurrencyConfigs = getCryptoCurrencyConfigForCryptoId(values[depositFormFields.cryptoCurrencyCode])

  const setUpdatedSectionNameDebounced = useMemo(() => debounce(setUpdatedSectionName, constants.timers['500']), [
    setUpdatedSectionName
  ])

  const onCoinsAmountChange = useCallback(
    (value, name) => {
      const numberValue = Number(value.replace(/,/g, ''))

      if (isNaN(numberValue) || numberValue <= 0) {
        return setFieldValue(name, '')
      }

      const computedValue = {
        [depositFormFields.cryptoAmount]: formatCurrencyAmountFromConfig(
          numberValue / config.gcToDollarExchangeRate / exchangeRate.price,
          cryptoCurrencyConfigs
        ),
        [depositFormFields.coinsAmount]: formatCurrencyAmount(
          numberValue * config.gcToDollarExchangeRate * exchangeRate.price,
          'GC'
        )
      }

      // allow crypto update only if GC more than 10000 (1 doll)
      if (Number(value) < config.gcToDollarExchangeRate && name === depositFormFields.cryptoAmount) {
        setFieldValue(name, '')

        return
      }

      setUpdatedSectionNameDebounced(name)

      setFieldValue(name, computedValue[name])
    },
    [cryptoCurrencyConfigs, setFieldValue, setUpdatedSectionNameDebounced, exchangeRate]
  )

  useEffect(() => {
    onCoinsAmountChange(values[depositFormFields.coinsAmount], depositFormFields.cryptoAmount)
  }, [exchangeRate])

  useEffect(() => {
    if (updatedSectionName) {
      sectionAnimationTimerRef.current = setTimeout(() => {
        setUpdatedSectionName('')
      }, constants.timers['2500'])
    }

    return () => clearTimeout(sectionAnimationTimerRef.current)
  }, [updatedSectionName])

  return { onCoinsAmountChange, cryptoCurrencyConfigs, updatedSectionName }
}
